import React, { useState, useEffect, useRef } from "react";

export default function CallCard({ stream }) {

    const videoRef = useRef(null);
    const [setup, setSetup] = useState(false);

    useEffect(() => {
        if (stream && !setup){
            videoRef.current.srcObject = stream
            setSetup(true)
        }
    }, [stream, setup])

    return(
        <div className="call__card">
            <video className="other" ref={videoRef} autoPlay={true} playsInline={true}></video>
            { !stream ? <div></div> : <></>}
        </div>
    )
}